<template>
  <el-dialog title="确认订单"
             :visible.sync="dialogVisible"
             width="570px"
             @close="handleClose">
    <el-form ref="dialogForm"
             :model="form"
             :rules="rules"
             label-position="left"
             label-width="80px"
             size="small">
      <!-- 商品信息区域 -->
      <div class="form-box">
        <div class="font1">{{ form.product_name }}</div>

        <div style="display: flex; align-items: center; gap: 12px; flex-wrap: wrap;">
          <el-form-item v-if="skus && skus.length > 0"
                        label="规  格:"
                        prop="currsku">
            <el-select v-model="form.currsku"
                       placeholder="请选择规格"
                       @change="handlePriceChange">
              <el-option v-for="item in skus"
                         :key="item.value"
                         :label="item.label"
                         :value="item" />
            </el-select>
          </el-form-item>

          <div style="height: 40px;"
               v-else>
            单 价：¥{{ form.product_price }}
          </div>

          <div v-if="form.sale_percent !== undefined"
               style="height: 40px;">
            | 折扣：{{ form.sale_percent }}%
          </div>
        </div>

        <el-form-item label="数  量:"
                      prop="quantity">
          <el-input-number v-model="form.quantity"
                           :min="minQuantity"
                           @change="handleQuantityChange" />
          <span style="margin-left: 10px; font-size: 12px; color: #909399;">
            起订份数: {{ minQuantity }}
          </span>
        </el-form-item>
        <div class="total-price"
             v-if="form.product_price">
          <div style="width:80px"> 总 价:</div>

          <span>{{ form.product_price }}</span> ×<span>{{ form.quantity }}</span> × <span>{{ form.sale_percent }}%</span> = <span>{{ form.total_amount }}元</span>
        </div>
        <!-- <div class="total-price">
          总价：¥{{ form.total_amount.toFixed(2) }}
        </div> -->
      </div>

      <!-- 支付方式区域 -->
      <TableTittle :tittle="TableName[0]" />

      <div class="form-box">
        <div class="payment-info">
          <div class="balance-info">
            <img src="https://upload.kaoyanbox.net/d533afaeb5a0f738d1f6cd8c1680e877.png"
                 style="width:32px; height:32px;"
                 alt="余额图标" />
            <div class="balance-text">
              余额支付：(可用余额 ¥{{ balance }})
            </div>
          </div>
          <img src="https://upload.kaoyanbox.net/5909411d1385d87bec6ebaa8338d5f07.png"
               style="width:21px; height:21px; cursor: pointer;"
               alt="帮助图标" />
        </div>
      </div>

      <!-- 收件信息区域（非必填） -->
      <!--  -->
      <div v-if="is_deliver==0&&product.service_user_type==2">
        <TableTittle :tittle="TableName[1]" />

        <div class="form-box">
          <el-form-item label="收件人"
                        prop="receiver_name">
            <el-input v-model="form.receiver_name"
                      placeholder="请输入收件人姓名"
                      style="width: 200px" />
          </el-form-item>

          <el-form-item label="收件号码"
                        prop="receiver_mobile">
            <el-input v-model="form.receiver_mobile"
                      placeholder="请输入收件号码"
                      style="width: 200px" />
          </el-form-item>

          <el-form-item label="收件地址"
                        prop="receiver_address">
            <el-input v-model="form.receiver_address"
                      placeholder="请输入收件地址"
                      type="textarea"
                      :rows="3"
                      style="width: 100%" />
          </el-form-item>
        </div>
      </div>

    </el-form>

    <div slot="footer"
         class="dialog-footer">
      <div>
        订单金额：
        <span class="order-amount">
          ¥{{ form.total_amount.toFixed(2) }}
        </span>
      </div>
      <div>
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary"
                   :loading="paying"
                   @click="handlePay"
                   v-if="balance>=form.total_amount">
          去支付
        </el-button>
        <el-button type="primary"
                   :loading="paying"
                   @click="handleRecharge"
                   v-else>
          余额不足 去充值
        </el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { adminUrl } from '../../../utils/helper'
import TableTittle from '../../../components/TableTittle/TableTittle.vue'

export default {
  name: 'ConfirmOrderDialog',

  components: {
    TableTittle,
  },

  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    product: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    // 手机号验证（仅当填写时才验证格式）
    const validatePhone = (rule, value, callback) => {
      if (value && !/^1[3-9]\d{9}$/.test(value)) {
        callback(new Error('请输入正确的手机号码'))
      } else {
        callback()
      }
    }

    // 地址验证（仅当填写时才验证长度）
    const validateAddress = (rule, value, callback) => {
      if (value && value.length < 5) {
        callback(new Error('地址信息过于简短，请填写详细地址'))
      } else {
        callback()
      }
    }

    return {
      is_deliver: false,
      TableName: ['支付方式', '收件信息'],
      skus: [],
      currsku: null,
      dialogVisible: false,
      paying: false,
      minQuantity: 1,
      form: {
        currsku: null,
        product_name: '',
        product_price: null,
        sale_percent: 100,
        quantity: 1,
        total_amount: 0,
        payment_method: '3',
        receiver_name: '',
        receiver_mobile: '',
        receiver_address: '',
      },
      rules: {
        currsku: [{ required: true, message: '请选择规格', trigger: 'blur' }],
        quantity: [
          { required: true, message: '请选择采购份数', trigger: 'blur' },
          {
            type: 'number',
            min: 1,
            message: '份数必须大于等于1',
            trigger: 'blur',
          },
        ],
        payment_method: [
          { required: true, message: '请选择支付方式', trigger: 'change' },
        ],
        // 收件信息非必填，只做格式验证（仅在填写时验证）
        receiver_name: [
          { required: true, message: '请输入收件人姓名', trigger: 'change' },

          {
            min: 2,
            max: 20,
            message: '姓名长度在2-20个字符之间',
            trigger: 'blur',
          },
        ],
        receiver_mobile: [
          { required: true, message: '请输入收件号码', trigger: 'change' },
          { validator: validatePhone, trigger: 'blur' },
        ],
        receiver_address: [
          { required: true, message: '请输入收件地址', trigger: 'change' },
          { validator: validateAddress, trigger: 'blur' },
        ],
      },
    }
  },

  computed: {
    balance() {
      return this.$store.state.AccountInfo?.balance || 0
    },
  },

  watch: {
    visible: {
      handler(val) {
        this.dialogVisible = val
        if (val) {
          this.initDialog()
        }
      },
      immediate: true,
    },

    product: {
      handler() {
        if (this.dialogVisible) {
          this.loadProductData()
          this.getProductSku()
        }
      },
      deep: true,
    },

    'form.product_price'() {
      this.calculateTotal()
    },

    'form.quantity'() {
      this.calculateTotal()
    },
  },

  methods: {
    handleRecharge() {
      this.$router.push('/finance/recharge')
      this.dialogVisible = false
    },
    // 初始化弹窗
    async initDialog() {
      await this.$store.dispatch('getCompanyAccount')
      this.loadProductData()
      await this.getProductSku()
    },

    // 获取商品SKU
    async getProductSku() {
      if (!this.product?.product_id || !this.product?.product_type) {
        return
      }

      const typeMap = {
        1: 'course',
        2: 'exam',
        3: 'material',
        4: 'article',
      }
      const path = typeMap[this.product.product_type]
      if (!path) return

      try {
        const str = adminUrl()
        const res = await this.$axios({
          url: `${str}/api/v1/${path}/content`,
          method: 'get',
          params: { product_id: this.product.product_id },
        })
        this.is_deliver = res.data.is_deliver

        if (!res.data.skus || res.data.skus.length == 0) {
          console.log('fuzhi')
          this.form.product_price = this.product.product_price || 0
        }
        const arr =
          res.data.skus?.map((sku) => {
            const propsStr = sku.properties?.map((p) => p.val).join(';') || ''
            const price = sku.price || 0
            const id = sku.id
            return {
              label: `${propsStr}${propsStr ? ';' : ''} | 单价¥${price}`,
              value: price,
              id: id,
            }
          }) || []

        this.skus = arr
      } catch (error) {
        console.error('获取SKU失败:', error)
        this.$message.error('获取商品规格失败')
      }
    },

    // 加载商品信息
    loadProductData() {
      if (!this.product || !Object.keys(this.product).length) {
        return
      }

      this.form.product_name = this.product.product_name || ''
      this.form.sale_percent = this.product.sale_percent ?? 100
      this.minQuantity = this.product.base_order_count || 1
      this.form.quantity = Math.max(this.minQuantity, this.form.quantity || 1)

      this.calculateTotal()
    },

    // 计算总金额
    calculateTotal() {
      const price = this.form.product_price || 0
      const percent = this.form.sale_percent / 100
      const quantity = this.form.quantity || 0
      const total = price * quantity * percent
      this.form.total_amount = Math.round(total * 100) / 100
    },

    // 价格变化处理
    handlePriceChange(e) {
      this.form.product_price = e.value
      this.form.product_sku_id = e.id
      this.calculateTotal()
    },

    // 数量变化处理
    handleQuantityChange(value) {
      if (value < this.minQuantity) {
        this.$nextTick(() => {
          this.form.quantity = this.minQuantity
        })
        this.$message.warning(`采购份数不能低于起订份数 ${this.minQuantity}`)
      }
      this.calculateTotal()
    },

    // 支付处理
    async handlePay() {
      // 只验证必填字段（数量和支付方式），收件信息可选不验证
      let isValid = true

      // 验证数量
      await this.$refs.dialogForm.validateField('currsku', (error) => {
        if (error) isValid = false
      })

      // 验证支付方式
      await this.$refs.dialogForm.validateField('payment_method', (error) => {
        if (error) isValid = false
      })
      //
      if (this.is_deliver == 0 && this.product.service_user_type == 2) {
        await this.$refs.dialogForm.validateField('receiver_name', (error) => {
          if (error) isValid = false
        })
        await this.$refs.dialogForm.validateField(
          'receiver_mobile',
          (error) => {
            if (error) isValid = false
          }
        )
        await this.$refs.dialogForm.validateField(
          'receiver_address',
          (error) => {
            if (error) isValid = false
          }
        )
      }

      if (!isValid) return

      const totalAmount = this.form.total_amount
      const balance = this.balance

      // if (this.form.payment_method === '3') {
      //   if (balance >= totalAmount) {
      await this.createOrderAndPay()
      // } else {
      //   this.$confirm('余额不足，是否前往充值？', '提示', {
      //     confirmButtonText: '去充值',
      //     cancelButtonText: '取消',
      //     type: 'warning',
      //   })
      //     .then(() => {
      //       this.$router.push('/finance/recharge')
      //       this.dialogVisible = false
      //     })
      //     .catch(() => {
      //       this.$message.info('已取消支付')
      //     })
      // }
      // }
    },

    // 创建订单并支付
    async createOrderAndPay() {
      if (this.paying) return
      this.paying = true

      try {
        const str = adminUrl()

        // 创建订单（收件信息可选，只传递已填写的字段）
        const orderData = {
          warrant_product_id: this.product.id,
          order_count: this.form.quantity,
          product_sku_id: this.form.product_sku_id,
        }

        // 只有填写了收件信息才传递
        if (this.form.receiver_name) {
          orderData.receiver_name = this.form.receiver_name
        }
        if (this.form.receiver_mobile) {
          orderData.receiver_mobile = this.form.receiver_mobile
        }
        if (this.form.receiver_address) {
          orderData.receiver_address = this.form.receiver_address
        }

        const orderRes = await this.$axios({
          url: `${str}/api/v1/back/crm/warrant/order`,
          method: 'post',
          data: orderData,
        })

        if (orderRes.code !== 0) {
          throw new Error(orderRes.message || '创建订单失败')
        }

        const orderId = orderRes.data?.insertId || orderRes.data?.order_id
        if (!orderId) {
          throw new Error('获取订单ID失败')
        }

        // 调用支付接口
        const paymentRes = await this.$axios({
          url: `${str}/api/v1/back/crm/payment`,
          method: 'post',
          data: {
            ref_id: orderId,
            ref_type: 5,
            pay_type: 3,
          },
        })

        if (paymentRes.code === 0) {
          this.$message.success('支付成功')
          this.dialogVisible = false
          this.$emit('pay-success', {
            order_id: orderId,
            product_id: this.product.id,
            quantity: this.form.quantity,
            total_amount: this.form.total_amount,
            receiver_name: this.form.receiver_name,
            receiver_mobile: this.form.receiver_mobile,
            receiver_address: this.form.receiver_address,
          })
        } else {
          throw new Error(paymentRes.message || '支付失败')
        }
      } catch (error) {
        console.error('支付失败:', error)
        this.$message.error(error.message || '支付失败，请重试')
      } finally {
        this.paying = false
      }
    },

    // 关闭弹窗
    handleClose() {
      this.dialogVisible = false
      this.$emit('update:visible', false)
      this.paying = false

      // 重置表单
      if (this.$refs.dialogForm) {
        this.$refs.dialogForm.resetFields()
      }

      // 重置状态
      this.form.quantity = this.minQuantity
      this.form.receiver_name = ''
      this.form.receiver_mobile = ''
      this.form.receiver_address = ''
      this.form.product_price = null
      this.calculateTotal()
    },
  },
}
</script>

<style scoped>
.dialog-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.form-box {
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  padding: 16px;
  margin-bottom: 16px;
}

.form-box:last-child {
  margin-bottom: 0;
}

.font1 {
  font-family: PingFang SC, sans-serif;
  font-weight: 500;
  font-size: 18px;
  color: #303133;
  line-height: 26px;
  margin-bottom: 16px;
}

.total-price {
  margin-top: 12px;
  font-weight: 500;
  display: flex;
  span {
    height: 23px;
    font-family: DINPro, DINPro;
    font-weight: bold;
    font-size: 18px;
    color: #409eff;
    line-height: 16px;
    text-align: left;
    font-style: normal;
    text-transform: none;
  }
}

.order-amount {
  color: #f56c6c;
  font-size: 18px;
  font-weight: bold;
}

.payment-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.balance-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.balance-text {
  height: 32px;
  line-height: 32px;
  margin-left: 16px;
}

/* 响应式调整 */
@media (max-width: 600px) {
  .dialog-footer {
    flex-direction: column;
    gap: 12px;
  }
}
</style>